import { TopolCarouslBlock } from "@/schemas/template/blocks/carouselBlockSchema";
import calcWidth from "./helpers";
import { v4 as uuidv4 } from "uuid";

export default {
  getData(
    state: any,
    props: { sectionIndex: number; columnIndex: number }
  ): TopolCarouslBlock {
    return {
      uid: uuidv4(),
      tagName: "mj-carousel",
      attributes: {
        "icon-width": "44px",
        "tb-width": "110px",
        "tb-border-radius": "6px",
        padding: "10px 15px 10px 15px",
        "tb-hover-border-color": "#fead0d",
        "left-icon":
          "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/arrows/arrow-3/simple/outline/black-L.png",
        "right-icon":
          "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/arrows/arrow-3/simple/outline/black-R.png",
        "tb-selected-border-color": "#cacaca",
        containerWidth: calcWidth(
          state.mjml.children[0].attributes["containerWidth"],
          state.mjml.children[0].children[props.sectionIndex].children[
            props.columnIndex
          ].attributes["width"]
        ),
      },

      children: [
        {
          tagName: "mj-carousel-image",
          attributes: {
            src: "",
          },
        },
        {
          tagName: "mj-carousel-image",
          attributes: {
            src: "",
          },
        },
        {
          tagName: "mj-carousel-image",
          attributes: {
            src: "",
          },
        },
      ],
    };
  },
};
